import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

import type { Milestone } from "@/views/PlanOfRecord/planOfRecordData";

export function MilestoneRowActions<T extends Milestone>({
  milestone,
  onEdit,
  onDelete,
}: {
  milestone: T;
  onEdit: (milestone: T) => void;
  onDelete: (milestone: T) => void;
}) {
  return (
    <div className="flex items-center gap-1">
      <Tooltip title="Edit milestone">
        <Button
          type="text"
          size="small"
          icon={<EditOutlined />}
          onClick={(event) => {
            // The row itself opens the drawer, so the action must not also trigger it.
            event.stopPropagation();
            onEdit(milestone);
          }}
        />
      </Tooltip>
      <Tooltip title="Delete milestone">
        <Button
          type="text"
          size="small"
          icon={<DeleteOutlined />}
          onClick={(event) => {
            event.stopPropagation();
            onDelete(milestone);
          }}
        />
      </Tooltip>
    </div>
  );
}
